/**
 * Transflo.WorkflowDefinition.HttpApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TemplateTypeEnum = 'None' | 'Regular' | 'Customer' | 'Division' | 'Global';

export const TemplateTypeEnum = {
    None: 'None' as TemplateTypeEnum,
    Regular: 'Regular' as TemplateTypeEnum,
    Customer: 'Customer' as TemplateTypeEnum,
    Division: 'Division' as TemplateTypeEnum,
    Global: 'Global' as TemplateTypeEnum
};

